"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreYoutubeVideo = _interopRequireDefault(require("@vfuk/core-youtube-video"));

var _coreBaseProps = require("@vfuk/core-base-props");

var _ContentVideo = require("./styles/ContentVideo.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ContentVideo = function ContentVideo(_ref) {
  var videoPosition = _ref.videoPosition,
      videoId = _ref.videoId,
      videoTitle = _ref.videoTitle,
      dataSelectorPrefix = _ref.dataSelectorPrefix;
  return /*#__PURE__*/_react["default"].createElement(_ContentVideo.VideoWrapper, {
    videoPosition: videoPosition
  }, /*#__PURE__*/_react["default"].createElement(_coreYoutubeVideo["default"], {
    videoId: videoId,
    title: videoTitle,
    showControls: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }));
};

ContentVideo.displayName = "ContentVideo";
var _default = ContentVideo;
exports["default"] = _default;
//# sourceMappingURL=ContentVideo.js.map